export default "__VITE_ASSET__B1Q8n79k__"